import React from 'react';
import { motion } from 'framer-motion';
export function WhatsAppWidget() {
  return <motion.a href="https://wa.me/447365536636" target="_blank" rel="noopener noreferrer" className="fixed bottom-[80px] md:bottom-28 right-6 z-50 flex items-center gap-3 bg-[#18181B] pl-4 pr-5 py-3 border border-white/[0.1] text-white text-[10px] uppercase tracking-widest font-bold no-underline hover:bg-white hover:text-black transition-colors group" initial={{
    opacity: 0,
    y: 20,
    scale: 0.9
  }} animate={{
    opacity: 1,
    y: 0,
    scale: 1
  }} transition={{
    delay: 2,
    type: 'spring',
    stiffness: 300,
    damping: 25
  }} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.97
  }} data-id="element-330">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="group-hover:text-black text-[#25D366] transition-colors" data-id="element-331">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" fill="currentColor" data-id="element-332" />
        <path d="M12 2C6.477 2 2 6.477 2 12c0 1.89.525 3.66 1.438 5.168L2 22l4.832-1.438A9.955 9.955 0 0012 22c5.523 0 10-4.477 10-10S17.523 2 12 2zm0 18a7.96 7.96 0 01-4.11-1.14l-.29-.174-3.01.79.8-2.93-.19-.3A7.96 7.96 0 014 12c0-4.41 3.59-8 8-8s8 3.59 8 8-3.59 8-8 8z" fill="currentColor" data-id="element-333" />
      </svg>
      <span data-id="element-334">WhatsApp</span>
    </motion.a>;
}